import { Button, ButtonProps } from '@cast/design-system';

import { useAbility } from '@cast/shared-ability-data-access';
import { useCreateEdgeLocationDrawer } from 'features/cluster/autoscaler/edge-locations/hooks';

import { useCluster } from '@cast/shared-cluster-context-data-access';

export const CreateEdgeLocationButton = (props: ButtonProps) => {
  const { cluster } = useCluster();
  const canCreate = useAbility().can('create', 'ClusterEdgeLocations');
  const { openCreateEdgeLocationDrawer } = useCreateEdgeLocationDrawer();

  return (
    <Button
      testId="create-edge-location-button"
      color="primary"
      disabled={!canCreate}
      onClick={() => {
        openCreateEdgeLocationDrawer({ clusterId: cluster.id });
      }}
      {...props}
    >
      Create edge location
    </Button>
  );
};
